// stock orders
export const CLEAR_DEALER_STOCK_ORDER = '@@toyota/CLEAR_DEALER_STOCK_ORDER';
export const CHECK_DEALER_STOCK_ORDER_REQUEST = '@@toyota/CHECK_DEALER_STOCK_ORDER_REQUEST';
export const CHECK_DEALER_STOCK_ORDER_SUCCESS = '@@toyota/CHECK_DEALER_STOCK_ORDER_SUCCESS';
export const CHECK_DEALER_STOCK_ORDER_FAILED = '@@toyota/CHECK_DEALER_STOCK_ORDER_FAILED';
export const CREATE_DEALER_STOCK_ORDER_REQUEST = '@@toyota/CREATE_DEALER_STOCK_ORDER_REQUEST';
export const CREATE_DEALER_STOCK_ORDER_SUCCESS = '@@toyota/CREATE_DEALER_STOCK_ORDER_SUCCESS';
export const CREATE_DEALER_STOCK_ORDER_FAILED = '@@toyota/CREATE_DEALER_STOCK_ORDER_FAILED';
export const GET_DEALER_NEXT_DISPATCH_TURN_REQUEST = '@@toyota/GET_DEALER_NEXT_DISPATCH_TURN_REQUEST';
export const GET_DEALER_NEXT_DISPATCH_TURN_SUCCESS = '@@toyota/GET_DEALER_NEXT_DISPATCH_TURN_SUCCESS';
export const GET_DEALER_NEXT_DISPATCH_TURN_FAILED = '@@toyota/GET_DEALER_NEXT_DISPATCH_TURN_FAILED';

// emerging orders
export const RESTORE_DEALER_EMERGING_ORDERS_PAGE = '@@toyota/RESTORE_DEALER_EMERGING_ORDERS_PAGE';
export const SELECT_DEALER_EMERGING_ORDER_CODE = '@@toyota/SELECT_DEALER_EMERGING_ORDER_CODE';
export const UPDATE_DEALER_EMERGING_ORDER_VALUE = '@@toyota/UPDATE_DEALER_EMERGING_ORDER_VALUE';
export const TOGGLE_CREATED_DEALER_EMERGING_MODAL = '@@toyota/TOGGLE_CREATED_DEALER_EMERGING_MODAL';
export const SEARCH_DEALER_EMERGING_ORDER_REQUEST = '@@toyota/SEARCH_DEALER_EMERGING_ORDER_REQUEST';
export const SEARCH_DEALER_EMERGING_ORDER_SUCCESS = '@@toyota/SEARCH_DEALER_EMERGING_ORDER_SUCCESS';
export const SEARCH_DEALER_EMERGING_ORDER_FAILED = '@@toyota/SEARCH_DEALER_EMERGING_ORDER_FAILED';
export const CREATE_DEALER_EMERGING_ORDER_REQUEST = '@@toyota/CREATE_DEALER_EMERGING_ORDER_REQUEST';
export const CREATE_DEALER_EMERGING_ORDER_SUCCESS = '@@toyota/CREATE_DEALER_EMERGING_ORDER_SUCCESS';
export const CREATE_DEALER_EMERGING_ORDER_FAILED = '@@toyota/CREATE_DEALER_EMERGING_ORDER_FAILED';
export const SAVE_DEALER_LOST_SALE_REQUEST = '@@toyota/SAVE_DEALER_LOST_SALE_REQUEST';
export const SAVE_DEALER_LOST_SALE_SUCCESS = '@@toyota/SAVE_DEALER_LOST_SALE_SUCCESS';
export const SAVE_DEALER_LOST_SALE_FAILED = '@@toyota/SAVE_DEALER_LOST_SALE_FAILED';

// special orders
export const RESTORE_DEALER_SPECIAL_ORDER = '@@toyota/RESTORE_DEALER_SPECIAL_ORDER';
export const REMOVE_ELEMENT_FROM_SPECIAL_ORDER = '@@toyota/REMOVE_ELEMENT_FROM_SPECIAL_ORDER';
export const CLOSE_DEALER_SPECIAL_ORDER_CONFIRMATION = '@@toyota/CLOSE_DEALER_SPECIAL_ORDER_CONFIRMATION';
export const GET_SPECIAL_ORDERS_REASONS_REQUEST = '@@toyota/GET_SPECIAL_ORDERS_REASONS_REQUEST';
export const GET_SPECIAL_ORDERS_REASONS_SUCCESS = '@@toyota/GET_SPECIAL_ORDERS_REASONS_SUCCESS';
export const GET_SPECIAL_ORDERS_REASONS_FAILED = '@@toyota/GET_SPECIAL_ORDERS_REASONS_FAILED';
export const CHECK_DEALER_SPECIAL_ORDER_ELEMENT_REQUEST = '@@toyota/CHECK_DEALER_SPECIAL_ORDER_ELEMENT_REQUEST';
export const CHECK_DEALER_SPECIAL_ORDER_ELEMENT_SUCCESS = '@@toyota/CHECK_DEALER_SPECIAL_ORDER_ELEMENT_SUCCESS';
export const CHECK_DEALER_SPECIAL_ORDER_ELEMENT_FAILED = '@@toyota/CHECK_DEALER_SPECIAL_ORDER_ELEMENT_FAILED';
export const CREATE_DEALER_SPECIAL_ORDER_REQUEST = '@@toyota/CREATE_DEALER_SPECIAL_ORDER_REQUEST';
export const CREATE_DEALER_SPECIAL_ORDER_SUCCESS = '@@toyota/CREATE_DEALER_SPECIAL_ORDER_SUCCESS';
export const CREATE_DEALER_SPECIAL_ORDER_FAILED = '@@toyota/CREATE_DEALER_SPECIAL_ORDER_FAILED';

// Grouped management
export const RESTORE_ORDERS_GROUPED_MANAGEMENT = '@@toyota/RESTORE_ORDERS_GROUPED_MANAGEMENT';
export const EDIT_ORDERS_GROUPED_MANAGEMENT_FILTER = '@@toyota/EDIT_ORDERS_GROUPED_MANAGEMENT_FILTER';

// tracking schedule
export const SELECT_ORDER_FOR_TRACKING_SCHEDULE = '@@toyota/SELECT_ORDER_FOR_TRACKING_SCHEDULE';
export const GET_ORDER_TRACKING_SCHEDULE_REQUEST = '@@toyota/GET_ORDER_TRACKING_SCHEDULE_REQUEST';
export const GET_ORDER_TRACKING_SCHEDULE_SUCCESS = '@@toyota/GET_ORDER_TRACKING_SCHEDULE_SUCCESS';
export const GET_ORDER_TRACKING_SCHEDULE_FAILED = '@@toyota/GET_ORDER_TRACKING_SCHEDULE_FAILED';
export const UPDATE_ORDER_TRACKING_STEP_REQUEST = '@@toyota/UPDATE_ORDER_TRACKING_STEP_REQUEST';
export const UPDATE_ORDER_TRACKING_STEP_SUCCESS = '@@toyota/UPDATE_ORDER_TRACKING_STEP_SUCCESS';
export const UPDATE_ORDER_TRACKING_STEP_FAILED = '@@toyota/UPDATE_ORDER_TRACKING_STEP_FAILED';

// POSS download
export const DOWNLOAD_POSS_FILE_REQUEST = '@@toyota/DOWNLOAD_POSS_FILE_REQUEST';
export const DOWNLOAD_POSS_FILE_SUCCESS = '@@toyota/DOWNLOAD_POSS_FILE_SUCCESS';
export const DOWNLOAD_POSS_FILE_FAILED = '@@toyota/DOWNLOAD_POSS_FILE_FAILED';

// Orders Management
export const RESTORE_DEALER_ORDERS_MANAGEMENT = '@@toyota/RESTORE_DEALER_ORDERS_MANAGEMENT';
export const EDIT_DEALER_ORDERS_MANAGEMENT_FILTER = '@@toyota/EDIT_DEALER_ORDERS_MANAGEMENT_FILTER';
export const GET_DEALER_ORDERS_LIST_REQUEST = '@@toyota/GET_DEALER_ORDERS_LIST_REQUEST';
export const GET_DEALER_ORDERS_LIST_SUCCESS = '@@toyota/GET_DEALER_ORDERS_LIST_SUCCESS';
export const GET_DEALER_ORDERS_LIST_FAILED = '@@toyota/GET_DEALER_ORDERS_LIST_FAILED';
export const SAVE_DEALER_ORDER_COMMENT_REQUEST = '@@toyota/SAVE_DEALER_ORDER_COMMENT_REQUEST';
export const SAVE_DEALER_ORDER_COMMENT_SUCCESS = '@@toyota/SAVE_DEALER_ORDER_COMMENT_SUCCESS';
export const SAVE_DEALER_ORDER_COMMENT_FAILED = '@@toyota/SAVE_DEALER_ORDER_COMMENT_FAILED';

// Orders tracking
export const RESTORE_DEALER_ORDERS_TRACKING = '@@toyota/RESTORE_DEALER_ORDERS_TRACKING';
export const EDIT_DEALER_ORDERS_TRACKING_FILTER = '@@toyota/EDIT_DEALER_ORDERS_TRACKING_FILTER';
export const GET_DEALER_ORDERS_TRACKING_REQUEST = '@@toyota/GET_DEALER_ORDERS_TRACKING_REQUEST';
export const GET_DEALER_ORDERS_TRACKING_SUCCESS = '@@toyota/GET_DEALER_ORDERS_TRACKING_SUCCESS';
export const GET_DEALER_ORDERS_TRACKING_FAILED = '@@toyota/GET_DEALER_ORDERS_TRACKING_FAILED';
export const DELETE_DEALER_ORDER_REQUEST = '@@toyota/DELETE_DEALER_ORDER_REQUEST';
export const DELETE_DEALER_ORDER_SUCCESS = '@@toyota/DELETE_DEALER_ORDER_SUCCESS';
export const DELETE_DEALER_ORDER_FAILED = '@@toyota/DELETE_DEALER_ORDER_FAILED';
export const DOWNLOAD_DEALER_ORDERS_REQUEST = '@@toyota/DOWNLOAD_DEALER_ORDERS_REQUEST';
export const DOWNLOAD_DEALER_ORDERS_SUCCESS = '@@toyota/DOWNLOAD_DEALER_ORDERS_SUCCESS';
export const DOWNLOAD_DEALER_ORDERS_FAILED = '@@toyota/DOWNLOAD_DEALER_ORDERS_FAILED';

// Lost Sales Report action types
export const CLEAR_LOST_SALES_REPORT_DETAIL = '@@toyota/CLEAR_LOST_SALES_REPORT_DETAIL';
export const CLEAR_LOST_SALES_SELECTED_PART = '@@toyota/CLEAR_LOST_SALES_SELECTED_PART';
export const UPDATE_LOST_SALES_REPORT_FILTERS = '@@toyota/UPDATE_LOST_SALES_REPORT_FILTER';
export const GET_LOST_SALES_REPORT = '@@toyota/GET_LOST_SALES_REPORT';
export const GET_LOST_SALES_REPORT_SUCCESS = '@@toyota/GET_LOST_SALES_REPORT_SUCCESS';
export const GET_LOST_SALES_REPORT_ERROR = '@@toyota/GET_LOST_SALES_REPORT_ERROR';
export const CHANGE_LOST_SALES_REPORT_DETAIL_LIST_PAGE = '@@toyota/CHANGE_LOST_SALES_REPORT_DETAIL_LIST_PAGE';
export const CHANGE_LOST_SALES_REPORT_DETAIL_LIST_PAGE_SIZE = '@@toyota/CHANGE_LOST_SALES_REPORT_DETAIL_LIST_PAGE_SIZE';
export const DOWNLOAD_LOST_SALES_REPORT_DETAIL = '@@toyota/DOWNLOAD_LOST_SALES_REPORT_DETAIL';
export const DOWNLOAD_LOST_SALES_REPORT_DETAIL_SUCCESS = '@@toyota/DOWNLOAD_LOST_SALES_REPORT_DETAIL_SUCCESS';
export const DOWNLOAD_LOST_SALES_REPORT_DETAIL_ERROR = '@@toyota/DOWNLOAD_LOST_SALES_REPORT_DETAIL_ERROR';
export const GET_PART_LOST_SALES_DETAIL_REQUEST = '@@toyota/GET_PART_LOST_SALES_DETAIL_REQUEST';
export const GET_PART_LOST_SALES_DETAIL_SUCCESS = '@@toyota/GET_PART_LOST_SALES_DETAIL_SUCCESS';
export const GET_PART_LOST_SALES_DETAIL_FAILED = '@@toyota/GET_PART_LOST_SALES_DETAIL_FAILED';
export const GENERATE_PART_LOST_SALES_REPORT_REQUEST = '@@toyota/GENERATE_PART_LOST_SALES_REPORT_REQUEST';
export const GENERATE_PART_LOST_SALES_REPORT_SUCCESS = '@@toyota/GENERATE_PART_LOST_SALES_REPORT_SUCCESS';
export const GENERATE_PART_LOST_SALES_REPORT_FAILED = '@@toyota/GENERATE_PART_LOST_SALES_REPORT_FAILED';

// Immobilized orders action types

export const FETCHING_IMMOBILIZED_DEALER_ORDERS = '@@toyota/FETCHING_IMMOBILIZED_DEALER_ORDERS';
export const FETCHED_IMMOBILIZED_DEALER_ORDERS = '@@toyota/FETCHED_IMMOBILIZED_DEALER_ORDERS';
export const FETCHED_IMMOBILIZED_DEALER_ORDERS_FAILED = '@@toyota/FETCHED_IMMOBILIZED_DEALER_ORDERS_FAILED';
export const DOWNLOAD_IMMOBILIZED_DEALER_ORDERS = '@@toyota/DOWNLOAD_IMMOBILIZED_DEALER_ORDERS';
export const DOWNLOAD_IMMOBILIZED_DEALER_ORDERS_SUCCESS = '@@toyota/DOWNLOAD_IMMOBILIZED_DEALER_ORDERS_SUCCESS';
export const DOWNLOAD_IMMOBILIZED_DEALER_ORDERS_FAILED = '@@toyota/DOWNLOAD_IMMOBILIZED_DEALER_ORDERS_FAILED';
export const CLEAR_IMMOBILIZED_DEALER_ORDERS = '@@toyota/CLEAR_IMMOBILIZED_DEALER_ORDERS';
export const CLEAR_IMMOBILIZED_DEALER_ORDERS_URL_FILE = '@@toyota/CLEAR_IMMOBILIZED_DEALER_ORDERS_URL_FILE';
export const CHANGE_IMMOBILIZED_DEALER_ORDERS_PAGE = '@@toyota/CHANGE_IMMOBILIZED_DEALER_ORDERS_PAGE';
export const CHANGE_IMMOBILIZED_DEALER_ORDERS_PAGE_SIZE = '@@toyota/CHANGE_IMMOBILIZED_DEALER_ORDERS_PAGE_SIZE';
// Vehicle inf
export const FETCHING_VEHICLE_INF = '@@toyota/FETCHING_VEHICLE_INF';
export const FETCHED_VEHICLE_INF = '@@toyota/FETCHED_VEHICLE_INF';
export const FETCHED_VEHICLE_INF_FAILED = '@@toyota/FETCHED_VEHICLE_INF_FAILED';


// eta management
export const GET_DEALER_ORDERS_ETA_MANAGEMENT_REQUEST = '@@toyota/GET_DEALER_ORDERS_ETA_MANAGEMENT_REQUEST';
export const GET_DEALER_ORDERS_ETA_MANAGEMENT_SUCCESS = '@@toyota/GET_DEALER_ORDERS_ETA_MANAGEMENT_SUCCESS';
export const GET_DEALER_ORDERS_ETA_MANAGEMENT_FAILED = '@@toyota/GET_DEALER_ORDERS_ETA_MANAGEMENT_FAILED';

export const GET_DEALER_ORDERS_ETA_MANAGEMENT_DETAIL_REQUEST =
  '@@toyota/GET_DEALER_ORDERS_ETA_MANAGEMENT_DETAIL_REQUEST';
export const GET_DEALER_ORDERS_ETA_MANAGEMENT_DETAIL_SUCCESS =
  '@@toyota/GET_DEALER_ORDERS_ETA_MANAGEMENT_DETAIL_SUCCESS';
export const GET_DEALER_ORDERS_ETA_MANAGEMENT_DETAIL_FAILED =
  '@@toyota/GET_DEALER_ORDERS_ETA_MANAGEMENT_DETAIL_FAILED';
export const EDIT_DEALER_ORDERS_ETA_MANAGEMENT_FILTERS =
  '@@toyota/EDIT_DEALER_ORDERS_ETA_MANAGEMENT_FILTERS';
export const CLEAN_DEALER_ORDERS_ETA_MANAGEMENT_FILTERS =
  '@@toyota/CLEAN_DEALER_ORDERS_ETA_MANAGEMENT_FILTERS';
export const CLEAN_DEALER_ORDERS_ETA_MANAGEMENT_DATA =
  '@@toyota/CLEAN_DEALER_ORDERS_ETA_MANAGEMENT_DATA';
